import { Scenarios } from '@jfs/network'

const checkRemittanceStatus = {
  default: [
    {
      url: /\/remittance\/jpb\/v1\/ats\/transaction\/status/,
      method: 'POST',
      response: {
        responseCode: '00',
        responseMessage: 'SUCCESS',
        responseData: {
          rrn: '367635581530',
          transactionId: '10672234363558153000',
          originalId: '10012234363562032000',
          idempotentKey: '1607062703409160_1',
          transactionNetAmount: 121.0,
          transactionGrossAmount: 122.0,
          transactionTime: 'Fri Dec 09 17:39:22 IST 2022',
          remitterMobile: '9718295765',
          beneficiaryName: 'Mchf Kgjgjf',
          beneficiaryAccountNumber: '123456789',
          beneficiaryBankName: 'HDFC0000077',
          transactions: [
            {
              transactionId: '10012424359119646000',
              rrn: '424316251453',
              amount: 5000.0,
              charges: 60.0,
              timestamp: 'Tue Sep 03 11:25:01 IST 2024',
              status: 'SUCCESS',
            },
            {
              transactionId: '10012424359131370000',
              rrn: '424316253447',
              amount: 5000.0,
              charges: 60.0,
              timestamp: 'Tue Sep 03 11:25:01 IST 2024',
              status: 'PENDING',
            },
            {
              transactionId: '10012424359146420000',
              rrn: '424316256382',
              amount: 5000.0,
              charges: 60.0,
              timestamp: 'Tue Sep 03 11:25:01 IST 2024',
              status: 'FAILED',
              error: {
                code: 'errorCode',
                message: 'errorMessage',
              },
            },
            {
              transactionId: '10012424359153820000',
              rrn: '424316257276',
              amount: 3.0,
              charges: 1.0,
              timestamp: 'Tue Sep 03 11:25:01 IST 2024',
              status: 'PROCESSED',
            },
          ],
        },
      },
      delay: 500,
    },
  ],
  failed: [
    {
      url: /user/,
      method: 'POST',
      responseCode: 55101,
      response: { status: 'FAILURE', error: { code: '33607', message: 'User does not exist.' } },
      delay: 1000,
    },
  ],
} as Scenarios

export { checkRemittanceStatus }
